import { Component, ElementRef, Inject, OnDestroy } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { IVehicle } from "../../models/vehicle";
import { Observable } from "rxjs/Observable";
import { IAccount } from "../../models/account";
import { DOCUMENT } from "@angular/common";
import { ISelectedAd } from "../../models/selectedad";
import { BehaviorSubject } from "rxjs";
import { EscapeProvider } from "../../providers/escape/escape";

@Component({
  selector: "page-sites",
  templateUrl: "sites.html",
})
export class SitesPage implements OnDestroy {
  public vehicle: IVehicle;
  public status: {};
  public accounts: IAccount[];
  public site: { sitecode: ""; sitename: "" };

  public selectedAdOrigin$: BehaviorSubject<ISelectedAd>;
  public selectedAd$: Observable<ISelectedAd>;
  public deSelectedAd$: Observable<ISelectedAd>;

  private readonly emptyAd: ISelectedAd = {
    selected: false,
    stockNumber: -1,
    site: { sitecode: "", sitename: "" },
    account: null,
    dimensions: { left: 0, top: 0, width: 0 },
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    @Inject(DOCUMENT) private document: HTMLDocument,
    private escape: EscapeProvider,
    private elementRef: ElementRef
  ) {
    this.vehicle = navParams.get("vehicle");
    this.status = navParams.get("status");
    this.accounts = navParams.get("accounts");
    this.site = navParams.get("site");

    this.selectedAdOrigin$ = new BehaviorSubject<ISelectedAd>(this.emptyAd);

    this.deSelectedAd$ = this.escape
      .start$(this.elementRef.nativeElement)
      .filter((el) => {
        return !el.matches(".ads-list *");
      })
      .map(() => this.emptyAd);

    this.selectedAd$ = Observable.merge(
      this.selectedAdOrigin$,
      this.deSelectedAd$
    )
      .distinctUntilChanged(
        (a, b) =>
          a.stockNumber === b.stockNumber && a.site.sitecode === b.site.sitecode
      )
      .shareReplay(1);
  }

  public ngOnDestroy() {
    this.escape.stop();
  }

  public sitenameBySitecode(sitecode: string) {
    const sitename = this.accounts.find(
      (account) => account.site_code === sitecode
    );

    return sitename ? sitename.name : sitecode;
  }

  public showSiteInfo(account, sitename) {
    const dimensions = this.getTableAdStyle();
    this.selectedAdOrigin$.next({
      selected: true,
      stockNumber: 0,
      site: { sitecode: account.site_code, sitename },
      account,
      dimensions,
    });
  }

  public closeModal() {
    this.navCtrl.pop();
    this.escape.stop();
  }

  private getTableAdStyle() {
    let dimensions;

    const left = Math.min(this.document.body.offsetWidth - 220, 140);

    const scrollContent = this.document.querySelector(
      "ion-modal .scroll-content"
    );

    dimensions = {
      "width.px": scrollContent.clientWidth - left - 32,
      "left.px": left,
      "top.px": 5,
    };

    return dimensions;
  }
}



// WEBPACK FOOTER //
// ./src/pages/sites/sites.ts